import { faker } from "@faker-js/faker";
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from "chart.js";
import { Bar } from "react-chartjs-2";
import { useReport } from "../../../tools/api";
import { useEffect, useState } from "react";
import "./chartpurchase.scss";
import { convertToJalaliWithTime, convertToJalaliWithoutTime } from "../../../tools/tools";
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const ChartPurchase = () => {
  const [labels, setLabels] = useState([]);
  const [dataChart, setDataChart] = useState({
    labels: [],
    datasets: [
      {
        label: "Dataset 1",
        data: [],
        backgroundColor: "rgb(255, 99, 132)",
        stack: "Stack 0",
      },
    ],
  });

  const { statisticalReportDCProductCountSales, statisticalReportEPProductCountSales, statisticalReportSPProductCountSales } = useReport();
  useEffect(() => {
    const initialServices = async () => {
      const statistDC = await statisticalReportDCProductCountSales();
      const statistEP = await statisticalReportEPProductCountSales();
      const statistSP = await statisticalReportSPProductCountSales();
      if (statistDC && !statistDC.HasError && statistEP && !statistEP.HasError && statistSP && !statistSP.HasError) {
        const resDate = [
          ...statistDC.Result.map((item) => item.date),
          ...statistEP.Result.map((item) => item.date),
          ...statistSP.Result.map((item) => item.date),
        ];
        let temp = resDate.sort();
        temp = [...new Set(temp)];
        setLabels(temp);
        setDataChart({
          labels: temp,
          datasets: [
            {
              label: "تعداد فروش شارژ",
              data: statistDC.Result.map((item) => item.count),
              backgroundColor: "rgba(97, 170, 255, 1)",
              stack: "Stack 0",
            },
            {
              label: "تعداد فروش بسته",
              data: statistEP.Result.map((item) => item.count),
              backgroundColor: "rgba(55, 179, 153, 1)",
              stack: "Stack 0",
            },
            {
              label: "تعداد فروش سیم‌کارت",
              data: statistSP.Result.map((item) => item.count),
              backgroundColor: "rgba(230, 66, 37, 1)",
              stack: "Stack 0",
            },
          ],
        });
      }
    };
    initialServices();
  }, []);
  return (
    <>
      <div className="holder-purchase-chart">
        <div className="title-purchase">
          <h2>تعداد فروش نماینده </h2>
        </div>
        <div className="holder-purchase">
          <div className="header">
            <h1 className="title"></h1>
          </div>
          <Bar
            options={{
              plugins: {
                title: {
                  display: false,
                  text: "نمودار نمایش فعالیت نماینده",
                },
                legend: {
                  display: true,
                  position: "top",
                  labels: {
                    font: {
                      family: "IRANSansX",
                    },
                    padding: 20, // اعمال پدینگ به لیجند
                  },
                },
                tooltip: {
                  callbacks: {
                    title: (tooltipItems) => {
                      let title = tooltipItems[0].label || "";
                      let GetRes = convertToJalaliWithoutTime(title);
                      return GetRes;
                    },
                  },
                  titleFont: {
                    family: "IRANSansX",
                  },
                  bodyFont: {
                    family: "IRANSansX",
                  },
                  rtl: true,
                },
              },
              responsive: true,
              interaction: {
                intersect: true,
              },
              scales: {
                x: {
                  stacked: true,
                  ticks: {
                    callback: function (val, index) {
                      return convertToJalaliWithTime(this.getLabelForValue(val));
                    },
                    font: {
                      family: "IRANSansX",
                    },
                  },
                },
                y: {
                  stacked: true,
                  ticks: {
                    callback: function (val, index) {
                      return parseInt(val);
                    },
                    font: {
                      family: "IRANSansX",
                    },
                  },
                },
              },
            }}
            data={dataChart}
          />
        </div>
      </div>
    </>
  );
};

export default ChartPurchase;
